<template>
  <ul class="menu-list">
    <MobileMenuItem v-for="item in items" :key="item.name" :item="item" :selected-item="selectedItem">
      <MobileMenuList v-if="item.subitems" :items="item.subitems" />
    </MobileMenuItem>
  </ul>
</template>

<script>
import MobileMenuItem from './mobile-menu-item';

export default {
  name: 'MobileMenuList',
  props: {
    items: {
      type: Array,
      default: null,
      required: false,
    },
    selectedItem: {
      type: Object,
      default: () => {},
      required: false,
    },
  },
  components: { MobileMenuItem },
};
</script>

<style lang="scss" scoped>
.menu-list {
  background-color: #ffffff;
  list-style: none;
  margin: 0;
}
</style>
